import React, { useState } from 'react';
import styled from '@emotion/styled';
import SuccessAnimation from './SuccessAnimation';

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  isolation: isolate;
  backdrop-filter: blur(2px);

  * {
    pointer-events: auto;
  }
`;

const ModalContent = styled.div`
  background: var(--al-bg);
  padding: 30px;
  border-radius: 4px;
  width: 500px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 2001;

  h2 {
    color: white;
    font-family: 'Montserrat', sans-serif;
    font-size: 24px;
    margin-bottom: 20px;
    font-weight: 600;
    text-transform: uppercase;
  }
`;

const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: white;
  font-family: 'Montserrat', sans-serif;
  text-transform: uppercase;
  font-size: 14px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 4px;
  background: white;
  color: black;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px #62E07D;
  }

  &::placeholder {
    color: #666;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 32px;
`;

const Button = styled.button`
  padding: 12px 24px;
  border-radius: 4px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 14px;
  cursor: pointer;
`;

const CancelButton = styled(Button)`
  background: #333;
  color: white;
  border: none;

  &:hover {
    background: #444;
  }
`;

const SaveButton = styled(Button)`
  background: #62E07D;
  color: black;
  border: none;

  &:hover {
    background: #50B366;
  }
`;

const AddProduct = ({ isOpen, onClose, onAdd, initialData = {} }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [formData, setFormData] = useState({
    styleNo: initialData?.styleNo || '',
    brand: initialData?.brand || '',
    description: initialData?.description || '',
    shortDescription: initialData?.shortDescription || '',
    cogs: initialData?.cogs || '',
    supplierUrl: initialData?.supplierUrl || ''
  });

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onAdd(formData);
    setShowSuccess(true);
    setTimeout(onClose, 2500);
  };

  const handleModalClick = (e) => {
    // Only close if clicking the outer modal background
    if (e.target === e.currentTarget) {
      e.stopPropagation(); // Stop event from reaching parent modals
      onClose();
    }
  };

  return (
    <Modal onClick={handleModalClick}>
      <ModalContent>
        <h2>Add New Product</h2>
        <form onSubmit={handleSubmit}>
          <FormGroup>
            <Label>Style No *</Label>
            <Input
              type="text"
              value={formData.styleNo}
              onChange={(e) => setFormData({...formData, styleNo: e.target.value})}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label>Brand</Label>
            <Input
              type="text"
              value={formData.brand}
              onChange={(e) => setFormData({...formData, brand: e.target.value})}
            />
          </FormGroup>
          <FormGroup>
            <Label>Supplier Description</Label>
            <Input
              type="text"
              value={formData.description}
              onChange={(e) => setFormData({...formData, description: e.target.value})}
            />
          </FormGroup>
          <FormGroup>
            <Label>Short Description</Label>
            <Input
              type="text"
              value={formData.shortDescription}
              onChange={(e) => setFormData({...formData, shortDescription: e.target.value})}
              placeholder="e.g., Raglan"
            />
          </FormGroup>
          <FormGroup>
            <Label>COGS</Label>
            <Input
              type="number"
              step="0.01"
              value={formData.cogs}
              onChange={(e) => setFormData({...formData, cogs: e.target.value})}
            />
          </FormGroup>
          <FormGroup>
            <Label>Supplier URL</Label>
            <Input
              type="url"
              value={formData.supplierUrl}
              onChange={(e) => setFormData({...formData, supplierUrl: e.target.value})}
              placeholder="https://supplier.com/product"
            />
          </FormGroup>
          <ButtonGroup>
            <CancelButton 
              type="button" 
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
            >
              Cancel
            </CancelButton>
            <SaveButton 
              type="submit"
              onClick={(e) => e.stopPropagation()}
            >
              Add Product
            </SaveButton>
          </ButtonGroup>
        </form>
        {showSuccess && (
          <SuccessAnimation 
            onComplete={() => setShowSuccess(false)}
          />
        )}
      </ModalContent>
    </Modal>
  );
};

export default AddProduct; 